<template>
  <div id="app">
    <!-- <leftNav></leftNav> -->
    <div class="main"><!--希望router-view和leftNav处于同级-->
      <router-view/>
    </div>
  </div>
</template>

<script>
// 引入左侧边框
// import leftNav from "@/components/common/leftNav";
export default {
  name: "App",
  components: {
    // leftNav
  }
};
</script>

<style>
#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.main {
  float: left;
  width: 100%;
  height: 100%;
  overflow: hidden; /*该div中可能含有其他div，一旦其他div超过这个div，就把其他内容超出的隐藏*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue